<div class="container main">
  <div class="row m-0">
    <div *ngFor="let room of roomList">
      <div class="col-md-6 p-2">
        <div class="room-card" (click)="navigate(room)">
          <div class="live-tag">
            <span>Live</span>
          </div>
          <div class="live-number-view">
            <span>{{room.numOfView || 0}}</span>
          </div>
          <span class="room-title">{{room.title}}</span>
            <span *ngIf="room.thumbnailUrl">
            <img [src]="room.thumbnailUrl" class="room-thumbnail">
            </span>
            <span *ngIf="!room.thumbnailUrl">
              <img [src]="defaultThumbnail" class="room-thumbnail">
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
